import { render, staticRenderFns } from "./WorkFlowDetail.vue?vue&type=template&id=c0a9e7ea&"
import script from "./WorkFlowDetail.vue?vue&type=script&lang=js&"
export * from "./WorkFlowDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.4@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports